import React from 'react';
import { Building2, HardHat, Compass, RotateCcw } from 'lucide-react';
import { Button } from '../ui/button';

export const PRODUITS = [
  { id: 'annuel', label: 'RCDS BATICO Annuel', desc: 'Couverture annuelle de votre activité', base: "Chiffre d'affaires HT annuel (€)", icon: Building2 },
  { id: 'nominative', label: 'RCDS BATICO Nominative', desc: 'Par chantier / marché', base: 'Montant HT du marché (€)', icon: HardHat },
  { id: 'archos', label: 'RCDS BATICO ARCHOS (PIB)', desc: 'Prestations intellectuelles : architectes, BET, maîtres d\'œuvre', base: 'Honoraires HT annuels (€)', icon: Compass },
];

export const RcdsProduitSelector = ({ value, onChange, onReset }) => (
  <div className="space-y-2" data-testid="q-produit-selector">
    <div className="flex items-center justify-between">
      <p className="text-xs font-semibold text-slate-600">Choisissez votre simulateur</p>
      {value && (
        <Button type="button" size="sm" variant="ghost" onClick={onReset} className="h-7 text-xs gap-1 text-slate-600" data-testid="q-sim-reset-btn">
          <RotateCcw className="h-3.5 w-3.5" /> Réinitialiser / changer de simulateur
        </Button>
      )}
    </div>
    <div className="grid grid-cols-1 sm:grid-cols-3 gap-2">
      {PRODUITS.map((p) => {
        const on = value === p.id;
        const Icon = p.icon;
        return (
          <button key={p.id} type="button" onClick={() => onChange(p.id)} data-testid={`q-produit-${p.id}`}
            className={`text-left rounded-lg border p-3 transition-colors ${on ? 'border-violet-600 bg-violet-600 text-white' : 'border-violet-200 bg-white hover:bg-violet-50'}`}>
            <Icon className={`h-4 w-4 mb-1 ${on ? 'text-white' : 'text-violet-600'}`} />
            <p className="text-xs font-semibold leading-tight">{p.label}</p>
            <p className={`text-[11px] leading-snug ${on ? 'text-violet-100' : 'text-slate-500'}`}>{p.desc}</p>
          </button>
        );
      })}
    </div>
  </div>
);
